import React, { useState } from "react";
import { connect } from "react-redux";
import LeaveTypeList from "./LeaveTypeList";
import CreateNewLeaveType from "./CreateNewLeaveType";

const Maincontent = () => {
  const [updatelist, setUpdatelist] = useState(true);

  return (
    <>
      <div className="site-layout-background main-frame">
        <CreateNewLeaveType
          setUpdatelist={setUpdatelist}
          updatelist={updatelist}
        />
        <LeaveTypeList updatelist={updatelist} setUpdatelist={setUpdatelist} />
      </div>
    </>
  );
};

export default connect()(Maincontent);
